module.exports = __webpack_public_path__ + "img/undraw_6.2e748555.svg";